module.exports = __webpack_public_path__ + "img/shape-metal_ab-mobile-gold@2x.648d3901.png";